import * as React from 'react'

interface IconProps {
  style?: React.CSSProperties
  className?: string
  fill?: string
}

export const ReloadIcon: React.FC<IconProps> = ({ style, className, fill = '#ffffff' }) => {
  return (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width='24px'
      height='24px'
      x='0px'
      y='0px'
      className={className}
      style={style}
      viewBox='0 0 24 24'
    >
      <g>
        <path
          fill={fill}
          d='M6.3,6.4c1.1-1,2.4-1.8,3.8-2.1c1.5-0.3,3-0.3,4.4,0.2c0.3,0.1,0.6,0.1,0.9-0.1C15.7,4.2,15.9,4,16,3.7
    C16.1,3.3,16.1,3,16,2.7c-0.1-0.3-0.4-0.5-0.7-0.6c-1.9-0.6-4-0.7-5.9-0.2C7.4,2.5,5.6,3.5,4.3,5S2,8.2,1.6,10.2
    c-0.4,1.9-0.2,4,0.6,5.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-1.4,0.9c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6
    c0,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3l4.3,0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.3-0.6l0.9-4.3
    c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2l-1.3,0.9c0,0-0.1,0-0.1,0
    c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1c-0.5-1.4-0.5-2.9-0.2-4.3C4.5,8.7,5.2,7.4,6.3,6.4z'
        />
        <path
          fill={fill}
          d='M23.7,5.9c0-0.2-0.1-0.4-0.3-0.5s-0.3-0.2-0.5-0.3l-4.4-1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.1
    c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.2,0.3l-1,4.3c0,0.2,0,0.4,0,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.3,0.2,0.5,0.2
    c0.2,0,0.4,0,0.6-0.1l1.4-0.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0.5,1.4,0.5,2.9,0.2,4.3
    c-0.3,1.4-1.1,2.7-2.1,3.8c-1.1,1-2.4,1.8-3.8,2.2c-1.5,0.4-3,0.3-4.4-0.1c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0.1-0.5,0.1
    c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2-0.1,0.3,0,0.5c0,0.2,0.1,0.3,0.1,0.5c0.1,0.1,0.2,0.3,0.3,0.4
    c0.1,0.1,0.3,0.2,0.4,0.2c1.9,0.6,4,0.6,5.9,0.1c1.9-0.5,3.7-1.6,5.1-3c1.4-1.5,2.3-3.3,2.6-5.2c0.4-1.9,0.2-4-0.6-5.8
    c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1l1.3-0.8c0.2-0.1,0.3-0.3,0.4-0.4C23.7,6.2,23.7,6.1,23.7,5.9z'
        />
      </g>
    </svg>
  )
}
